import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { fetchImageByName } from "../../utils/utility";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  bgClinic: {
    width: "100vw",
    height: "100vh",
  },
}));

export default function BackgroundCarousel() {
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));
  const classes = useStyles();
  const mobileItems = [
    <img
      src={fetchImageByName("mobilePresentation")}
      className={classes.bgClinic}
      alt="Clinic"
    />,
    <img
      src={fetchImageByName("mobileBed")}
      className={classes.bgClinic}
      alt="Bed"
    />,
    <img
      src={fetchImageByName("mobileStage")}
      className={classes.bgClinic}
      alt="Stage"
    />,
  ];
  const desktopItems = [
    <img
      src={fetchImageByName("presentation")}
      className={classes.bgClinic}
      alt="Clinic"
    />,
    <img
      src={fetchImageByName("bed")}
      className={classes.bgClinic}
      alt="Bed"
    />,
    <img
      src={fetchImageByName("stageCarousel")}
      className={classes.bgClinic}
      alt="Stage"
    />,
  ];
  return (
    <AliceCarousel
      autoPlay
      infinite={true}
      autoPlayInterval="3000"
      items={isWidthSm ? mobileItems : desktopItems}
    />
  );
}
